// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__WiTdp","subtitle":"styles_subtitle__TsnVT","caption":"styles_caption__3p32b"};